import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "page" }
const _hoisted_2 = { id: "main" }

import loadingoverlay from "./views/Loading.vue";
import { watchEffect } from "vue";
import { authStore } from "@/stores/useAuthStore";
import { useToastStore } from "./stores/toasts.store";
import { hashCode } from "./utils/toast-utils";
import { Toast, ToastMessageOptions } from "primevue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const auth = authStore();
const toastStore = useToastStore();

// const notificationApi = new NotificationsApi(medServerApiConfig);

// const getAppUserUuid = (async (): Promise<string | undefined> => {
//   const healthGroup = await appUser.getCurrentHealthGroupMembership();

//   if (!healthGroup.pwr) return undefined
//   if (!healthGroup.pwr.appUserId) return undefined 

//   return healthGroup.pwr.appUserId;
// });

// const displayInAppNotifications = (notifications: SingleNotificationResponse[]) => {
//   notifications.forEach((notification) => {
//     toastInfo(toast, { summary: notification.message, detail: "" });
//   });
// };

const onToastClose = (message: ToastMessageOptions) => {
  const hash = hashCode(`${message.summary}${message.detail}`);
  if (toastStore.hasToast(hash)) {
    toastStore.removeToast(hash);
  }
};

// const findNotificationsByPersonUuid = async (personUuid: string) => {
//   const findNotificationsByPersonUuidRequest: FindNotificationsByPersonUuidRequest = {
//     personUuid: personUuid
//   };

//   return (await notificationApi.findNotificationsByPersonUuid(findNotificationsByPersonUuidRequest)).map(notification => ({
//     ...notification,
//     message: notification.message.replace(notification.priority, t(`notifications.${notification.priority}`))
//   }));
// };

// const startInAppNotificationPolling = (personUuid: string) => {
//   setInterval(async () => {
//     await findNotificationsByPersonUuid(personUuid).then((notifications) => {
//       displayInAppNotifications(notifications.filter(notification => notification.priority === NotificationPriorityEnum.Highest));
//     }).catch((error) => {
//       toastError(toast, { 
//         summary: t("common.toast.error"),             
//         detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
//       });
//     });
//   }, 10000);
// };

watchEffect(() => {
  if (auth.isAuthenticated) {
    auth.startTokenRefresh();
  }
});

// onMounted(async () => {
//   const personUuid = await getAppUserUuid();
//   startInAppNotificationPolling(personUuid)
// });


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Toast), { onClose: onToastClose }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(loadingoverlay),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { id: "modal" }, null, -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { id: "dropd" }, null, -1))
    ])
  ], 64))
}
}

})